import { Component } from '@angular/core';
import { FBAbstractControl } from '../abstract.control';

@Component({
  selector: 'fb-controls-editable-grid',
  templateUrl: './editable-grid.component.html',
})
export class FBControlsCustomControlComponent extends FBAbstractControl {
  constructor() {
    super();
  }

  static PROPERTIES() {
    return Object.freeze({
      common: {
        ...FBAbstractControl.DefaultProperties(),
      },
      booleans: {
        ...FBAbstractControl.BooleansProperties(),
      },
    });
  }
}
